import React from 'react';
import './DateSelector.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

const DateSelector = ({ curDate, onCurDateChange }) => {

  const handlePrevDate = () => {
    const newDate = new Date(curDate.setDate(curDate.getDate() - 1));
    onCurDateChange(newDate);
  };

  const handleNextDate = () => {
    const newDate = new Date(curDate.setDate(curDate.getDate() + 1));
    onCurDateChange(newDate);
  };  
  
  return (
    <div>
        <button onClick={handlePrevDate} className="previous-button"><FontAwesomeIcon icon={faArrowLeft} /></button>
        <span className="curdate-span">{curDate.toDateString()}</span>
        <button onClick={handleNextDate} className="next-button"><FontAwesomeIcon icon={faArrowRight} /></button>
    </div>
  );
};

export default DateSelector;